import { jsx as _jsx } from "react/jsx-runtime";
import MenuIcon from "./components/MenuIcon";
import MenuItem from "./components/MenuItem";
import MenuLabel from "./components/MenuLabel";
import cn from "../../utils/cn";
const Menu = ({ children, className }) => {
    return _jsx("div", { className: cn("flex flex-col px-2 py-2.5", className), children: children });
};
Menu.Item = MenuItem;
Menu.Label = MenuLabel;
Menu.Icon = MenuIcon;
export default Menu;
